var React = require('react');

function Factor8 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M11 0C4.93026 0 0 4.93026 0 11C0 17.0697 4.93026 22 11 22C17.0697 22 22 17.0697 22 11C22 4.93026 17.0697 0 11 0ZM11 20.3077C5.86667 20.3077 1.69231 16.1333 1.69231 11C1.69231 5.86667 5.86667 1.69231 11 1.69231C16.1333 1.69231 20.3077 5.86667 20.3077 11C20.3077 16.1333 16.1333 20.3077 11 20.3077Z","fill":"#6F16FF","key":0}),React.createElement("path",{"d":"M14.9195 8.14675L9.87639 13.1898L7.08972 10.4032C6.76254 10.076 6.221 10.076 5.89382 10.4032C5.56664 10.7303 5.56664 11.2719 5.89382 11.5991L9.27844 14.9837C9.44767 15.1529 9.66203 15.2319 9.87639 15.2319C10.0907 15.2319 10.3051 15.1529 10.4743 14.9837L16.1154 9.34265C16.4425 9.01547 16.4425 8.47393 16.1154 8.14675C15.7882 7.81957 15.2466 7.81957 14.9195 8.14675Z","fill":"#6F16FF","key":1})]);
}

Factor8.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none"};

module.exports = Factor8;

Factor8.default = Factor8;
